module.exports = __webpack_public_path__ + "fonts/PFBeauSansPro-Bold.73ffce4e.woff2";